<template>
  <div class="groupHead">
    <span class="gdot" :style="{ background: color }"></span>
    <span class="gname">{{ name }}</span>
    <slot />
    <span class="gcount">{{ count }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{ color: string; name: string; count: string | number }>()
</script>

<style scoped>
.groupHead { display: flex; align-items: center; gap: var(--space-2); padding: var(--space-4) var(--space-4) var(--space-2); }
.gdot { width: 7px; height: 7px; border-radius: 999px; flex-shrink: 0; }
.gname { flex: 1; font-size: 11px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; color: var(--color-text-secondary); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.gcount { font-size: 11px; font-weight: 700; color: var(--color-text-tertiary); }

@container rail (max-width: 120px) {
  .groupHead { justify-content: center; padding: var(--space-3) 0 var(--space-1); }
  .gname, .gcount { display: none; }
}
</style>
